import { Search } from 'lucide-react'
import { useSearch } from './SearchProvider.jsx'

const IS_MAC = typeof navigator !== 'undefined' && /Mac/.test(navigator.platform)

// `tone="dark"` is the main sidebar (navy). The patient sidebar stays white and
// uses the default light tone — the two menus are meant to look different.
export default function SearchTrigger({ collapsed = false, tone = 'light' }) {
  const { openSearch } = useSearch()
  const dark = tone === 'dark'
  if (collapsed) {
    return (
      <button
        type="button"
        onClick={openSearch}
        title="ค้นหาผู้ป่วย (⌘K)"
        className={`w-full flex items-center justify-center py-2 rounded-lg transition-colors ${
          dark ? 'text-brand-100/80 hover:text-white hover:bg-white/10' : 'text-slate-500 hover:text-brand-600 hover:bg-slate-50'
        }`}
      >
        <Search size={17} strokeWidth={1.75} />
      </button>
    )
  }
  return (
    <button
      type="button"
      onClick={openSearch}
      className={`group w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg border text-left transition-colors ${
        dark
          ? 'border-white/15 bg-white/10 hover:bg-white/20 hover:border-white/25'
          : 'border-slate-200 bg-white hover:border-brand-300 hover:bg-brand-50/40'
      }`}
    >
      <Search size={15} className={`transition-colors flex-none ${dark ? 'text-brand-100/70 group-hover:text-white' : 'text-slate-400 group-hover:text-brand-600'}`} strokeWidth={1.75} />
      <span className={`flex-1 text-[14px] truncate transition-colors ${dark ? 'text-brand-100/80 group-hover:text-white' : 'text-slate-500 group-hover:text-slate-700'}`}>
        ค้นหาผู้ป่วย
      </span>
      <kbd className={`text-[11.5px] font-mono rounded px-1 py-0.5 leading-none border ${
        dark ? 'text-brand-100/70 bg-white/10 border-white/15' : 'text-slate-400 bg-slate-50 border-slate-200'
      }`}>
        {IS_MAC ? '⌘K' : 'Ctrl K'}
      </kbd>
    </button>
  )
}
